import { createSelector } from 'reselect'

import { selectStrategicInitiativesOfferingOptions } from './selectStrategicInitiativesOfferingOptions'
import { selectStrategicInitiativesState } from './selectStrategicInitiativesState'

export const selectStrategicInitiativesSelectedOffering = createSelector(
  [selectStrategicInitiativesState, selectStrategicInitiativesOfferingOptions],
  ({ selectedOffering }, offeringOptions) =>
    selectedOffering !== null && offeringOptions.includes(selectedOffering)
      ? selectedOffering
      : (offeringOptions[0] ?? null)
)
